export { PasteHandler, default as default } from './PasteHandler.js'
